const liff = window.liff;
let isInit = false;
let profile = {};
let liffInfo = {};

class liffHelper {
  async init() {
    if (!isInit) {
      try {
        let data = await liff.init({ liffId: "1653882163-AbYgw2G5" })
        liffInfo = data
        isInit = true
      } catch (e) {
        console.log('Fail to init LIFF, please run inside LINE only');
      }
    } else {
      console.log("do nothing")
    }
  }

  getLIFFInfo() {
    return liffInfo;
  }

  getLiff() {
    return liff
  }

  async getProfile() {
    // try {
    //   await this.init()
    // } catch (e) {
    //   throw new Error(e)
    // }

    if (isInit && !profile.userId) {
      try {
        let pf = await liff.getProfile()
        profile = pf
        return pf
      } catch (e) {
        throw new Error(e)
      }
    } else {
      return profile
    }
  }

  closeWindow() {
    liff.closeWindow();
  }

  openWindow(url, external) {
    liff.openWindow({ url, external });
  }

  sendMessages(messages) {
    const messagesToSend = Array.isArray(messages) ? messages : [messages];
    return new Promise((resolve, reject) => {
      this.init()
        .then(() => {
          liff.sendMessages(messagesToSend)
            .then(() => {
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};
export default new liffHelper();


// WEBPACK FOOTER //
// ./src/utils/liffHelper.js